<template>
    <footer id="footer" class="d-flex">
        <div class="ft-transparent"></div>
        <div class="container">
            <div class="footer-container">
                <div class="footer-top d-flex justify-content-between align-items-center">
                    <nav class="footer-policies d-flex align-items-center">
                        <a class="policy-link" v-for="item in policy_link" :key="item.hash"
                            :href="policyUrl(item.hash)" target="_blank" rel="noopener">
                            {{ $t(item.lang_key) }}
                        </a>
                    </nav>
                    <div class="d-flex align-items-center gap-3">
                        <a class="d-flex justify-content-center" v-for="(item, index) in social_link" :key="index" @click.prevent="handleGACustomEvent(item)" target="_blank">
                            <img :src="item.icon" :alt="item.name">
                        </a>
                    </div>
                </div>
                <div class="copy-right-txt" v-html="$t('copy_right')"></div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "FooterElement",

    data() {
        return {
            policy_link: [
                { lang_key: "general_policy", hash: "terms" },
                { lang_key: "privacy_policy", hash: "privacy" },
                { lang_key: "delivery_policy", hash: "delivery" },
                { lang_key: "refund_policy", hash: "refund" },
            ],
            social_link: [
                { name: "Facebook", url: "https://www.facebook.com/ismart.teachers", ga_event: "IP2_W_1005", icon: "/themes/ito/images/social-fb.svg" },
                { name: "Youtube", url: "https://www.youtube.com/user/DigiClassVietnam", ga_event: "IP2_W_1006", icon: "/themes/ito/images/social-ytb.svg" },
                { name: "Twitter", url: "https://twitter.com/iSMARTEducatio1", ga_event: "IP2_W_1007", icon: "/themes/ito/images/social-instagram.svg" },
            ]
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }
            return {
                name: '',
                fullname: 'Guest',
            }
        })
    },

    // updated: function () {
    //     this.$nextTick(function () {
    //         App.init();
    //     })
    // },

    methods: {
        policyUrl(hash) {
            return this.$router.resolve({ path: '/general-principle', hash: '#' + hash }).href
        },

        handleGACustomEvent(element) {
            window.open(element.url, '_blank')
            const user_id = this.user_info.user_id || 0;
            var params = {
                'w_user_id': user_id
            }
            params[element.ga_event] = user_id
            gtag('event', element.ga_event, params)
        }
    }
}
</script>

<style scoped>
.footer-policies {
    column-gap: 32px;
    row-gap: 6px;
    flex-wrap: wrap;
}

.policy-link,
.policy-link:hover,
.policy-link:focus {
    color: inherit;
    white-space: nowrap;
}

.policy-link {
    text-decoration: none;
}

.policy-link:hover,
.policy-link:focus {
    text-decoration: underline;
}

.copy-right-txt {
    margin-top: 6px;
}
</style>
